// Textos de Rift Cargo en castellano, inglés y portugués. Se elige por el idioma del navegador o
// por lo que el jugador haya elegido (guardado en localStorage).

const ES = {
  'brand': 'Rift Cargo',
  'view.station': 'Estación',
  'view.map': 'Mapa del sistema',
  'hub.name': 'Nodo Rift',
  'hub.sub': '{full}% lleno · {busy}/{docks} muelles',
  'live': 'En vivo',
  'paused': 'Pausa',
  'speed': 'Velocidad',
  'role': 'Jefe de operaciones',
  'level': 'Nivel {n}',
  'kpi.stock': 'Stock en depósito',
  'kpi.stockSub': 'de {cap} t',
  'kpi.fleet': 'Naves en ruta',
  'kpi.fleetSub': '{n} en la estación',
  'kpi.ontime': 'Entregas a tiempo',
  'kpi.ontimeSub': '{n} entregas',
  'kpi.income': 'Ingresos',
  'kpi.incomeSub': 'últimos 5 min',
  'tab.orders': 'Pedidos',
  'tab.market': 'Mercado',
  'tab.fleet': 'Flota',
  'tab.station': 'Estación',
  'tab.map': 'Mapa',
  'orders.title': 'Pedidos y fletes',
  'orders.empty': 'No hay pedidos ahora. Llegan nuevos cada pocos segundos.',
  'order.wants': '{port} pide {tons} t de {cargo}',
  'freight.title': 'Flete: {tons} t de {cargo}',
  'freight.route': '{from} → {to}',
  'order.fromDepot': 'Sale del depósito',
  'order.urgent': 'Urgente',
  'order.due': 'Entregar en {t}',
  'order.expires': 'La oferta vence en {t}',
  'order.send': 'Enviar',
  'order.sendWith': 'Enviar con {ship}',
  'order.pickShip': 'Elegí la nave',
  'order.noStock': 'Falta stock: tenés {have} t de {cargo}',
  'order.buyMore': 'Comprar en {port}',
  'order.noShip': 'No hay naves libres con lugar para {tons} t',
  'order.arrives': 'Entrega en {t}',
  'order.late': 'llegaría tarde',
  'order.onTime': 'a tiempo',
  'order.net': 'Ganás {v}',
  'order.fuel': 'combustible {v}',
  'market.title': 'Mercado',
  'market.depot': 'Depósito',
  'market.free': '{free} t libres de {cap} t',
  'market.sells': 'Vende {cargo}',
  'market.price': '{v} por t',
  'market.buyWith': 'Comprar {tons} t con {ship}',
  'market.total': 'Total {v} con combustible',
  'market.noSpace': 'El depósito está lleno',
  'market.noShip': 'No hay naves libres',
  'market.locked': 'Se habilita en el nivel {n}',
  'market.back': 'Vuelve en {t}',
  'fleet.title': 'Flota',
  'fleet.hangar': 'Hangar: {n} de {cap} lugares',
  'fleet.buy': 'Comprar nave',
  'fleet.cap': '{t} t',
  'fleet.speed': 'Velocidad {v}',
  'fleet.auto': 'Piloto automático',
  'fleet.autoLocked': 'Mejorá la estación para usar piloto automático',
  'auto.off': 'Apagado',
  'auto.supply': 'Reponer stock',
  'auto.orders': 'Cumplir pedidos',
  'auto.freight': 'Hacer fletes',
  'fleet.full': 'Hangar lleno: ampliá el hangar',
  'fleet.trips': '{n} viajes · ganó {v}',
  'station.title': 'Mejoras de la estación',
  'station.stats': 'Tu empresa',
  'up.docks': 'Muelles',
  'up.docks.d': 'Más naves cargando a la vez',
  'up.drones': 'Drones de carga',
  'up.drones.d': 'Cargan y descargan más rápido',
  'up.depot': 'Depósito',
  'up.depot.d': 'Más toneladas de stock',
  'up.hangar': 'Hangar',
  'up.hangar.d': 'Lugar para más naves',
  'up.engines': 'Motores',
  'up.engines.d': 'Toda la flota viaja más rápido',
  'up.shields': 'Escudos',
  'up.shields.d': 'Cruzar el cinturón de asteroides sin frenar',
  'up.autopilot': 'Piloto automático',
  'up.autopilot.d': 'Las naves trabajan solas, incluso con el juego cerrado',
  'up.max': 'Al máximo',
  'up.buy': 'Mejorar',
  'up.needLevel': 'Nivel {n}',
  'stat.earned': 'Ganancias',
  'stat.delivered': 'Entregas',
  'stat.tons': 'Toneladas movidas',
  'stat.spent': 'Gastos',
  'status.parked': 'En el hangar',
  'status.queued': 'Esperando muelle',
  'status.docking': 'Entrando al muelle',
  'status.docked': 'En el muelle',
  'status.waitdrones': 'Esperando drones',
  'status.working': 'Cargando',
  'status.unloading': 'Descargando',
  'status.liftoff': 'Despegando',
  'status.travel': 'Viajando a {to}',
  'status.portwork': 'Operando en {port}',
  'status.landing': 'Aterrizando',
  'pill.idle': 'Disponible',
  'pill.loading': 'Cargando',
  'pill.route': 'En ruta',
  'pill.port': 'En puerto',
  'pill.wait': 'En espera',
  'track.title': 'Seguimiento de envío',
  'track.none': 'Mandá una nave a un pedido para seguirlo acá.',
  'track.order': 'Pedido #{id}',
  'track.buy': 'Compra #{id}',
  'track.freight': 'Flete #{id}',
  'track.accepted': 'Aceptado',
  'track.loading': 'Carga',
  'track.transit': 'En viaje',
  'track.delivered': 'Entregado',
  'track.return': 'Regreso',
  'track.bought': 'Compra',
  'track.pickup': 'Retiro',
  'track.unload': 'Descarga',
  'track.to': 'A {port}',
  'track.eta': 'llega en {t}',
  'track.dock': 'Muelle {n}',
  'detail.cargo': 'Carga',
  'detail.dest': 'Destino',
  'detail.eta': 'Llegada',
  'detail.model': 'Modelo',
  'detail.cap': 'Capacidad',
  'detail.trips': 'Viajes',
  'detail.earned': 'Ganó',
  'detail.follow': 'Seguir con la cámara',
  'detail.empty': 'Vacía',
  'cam.in': 'Acercar',
  'cam.out': 'Alejar',
  'cam.left': 'Girar a la izquierda',
  'cam.right': 'Girar a la derecha',
  'cam.home': 'Volver a la estación',
  'toast.delivered': '{ship} entregó {tons} t de {cargo} en {port}',
  'toast.late': '{ship} llegó tarde a {port}: cobra la mitad',
  'toast.loaded': '{ship} cargó {tons} t de {cargo} en {port}',
  'toast.level': '¡Subiste al nivel {n}!',
  'toast.newShip': 'Nueva nave en el hangar: {ship}',
  'toast.upgrade': 'Mejora lista: {name}',
  'toast.expired': 'Se venció una oferta de {port}',
  'toast.err.money': 'No alcanza la plata',
  'toast.err.stock': 'No hay stock suficiente',
  'toast.err.space': 'No hay lugar en el depósito',
  'toast.err.busy': 'Esa nave está ocupada',
  'toast.err.cap': 'No entra en esa nave',
  'toast.err.level': 'Todavía no tenés el nivel',
  'toast.err.hangar': 'No hay lugar en el hangar',
  'toast.err.gone': 'Esa oferta ya no está',
  'toast.err.locked': 'Todavía no está habilitado',
  'unlock.title': 'Nivel {n}',
  'unlock.sub': 'Tu reputación crece. Se habilitó:',
  'unlock.ok': '¡Vamos!',
  'unlock.port': 'Nuevo planeta: {port}',
  'unlock.ship': 'Nueva nave: {ship}',
  'unlock.up': 'Mejora: {name}',
  'unlock.more': 'Pedidos más grandes y mejor pagos',
  'away.title': 'Mientras no estabas',
  'away.sub': 'Tu flota siguió trabajando {t}.',
  'away.earned': 'Ganancia',
  'away.delivered': 'Entregas',
  'away.ok': 'Seguir',
  'away.tip': 'Con piloto automático tus naves trabajan aunque cierres el juego.',
  'tut.1': '¡Bienvenido a Rift Cargo! Sos el jefe de operaciones del Nodo Rift, una estación de carga. Llegó tu primer pedido: Vesta necesita agua.',
  'tut.1b': 'Tocá Enviar para mandar una nave.',
  'tut.2': 'Los drones llevan los contenedores desde las estanterías hasta la nave en el muelle.',
  'tut.3': 'La nave sale hacia Vesta. Abrí el mapa para ver la ruta.',
  'tut.4': 'Los planetas giran alrededor del sol: las distancias cambian todo el tiempo. Un viaje corto gasta menos combustible y llega antes.',
  'tut.5': 'Para tener stock, comprá carga en el Mercado. Después la vendés con los pedidos.',
  'tut.next': 'Siguiente',
  'tut.ok': 'Entendido',
  'tut.skip': 'Saltar',
  'ship.colibri': 'Colibrí',
  'ship.mula': 'Mula',
  'ship.titan': 'Titán',
  'ship.colibri.d': 'Liviana y rápida',
  'ship.mula.d': 'El caballo de batalla',
  'ship.titan.d': 'Carguero pesado',
  'ship.vencejo': 'Vencejo',
  'ship.libelula': 'Libélula',
  'ship.halcon': 'Halcón Rift',
  'ship.raya': 'Raya',
  'ship.nomada': 'Nómada',
  'ship.bisonte': 'Bisonte',
  'ship.nova': 'Nova',
  'ship.leviatan': 'Leviatán',
  'ship.coloso': 'Coloso',
  'ship.vencejo.d': 'Ala delta con doble cola: la más rápida de las livianas',
  'ship.libelula.d': 'Cuatro alas con paneles solares: gasta muy poco',
  'ship.halcon.d': 'Blindada y de alas invertidas: cruza el cinturón sin frenar',
  'ship.raya.d': 'Cuerpo de manta, plano y veloz',
  'ship.nomada.d': 'Caravana con velas solares y motor iónico: la más económica',
  'ship.bisonte.d': 'Blindaje pesado y espolón: el cinturón no la frena',
  'ship.nova.d': 'Crucero con anillo acelerador: el pesado más rápido',
  'ship.leviatan.d': 'Ballena del espacio con luz propia: gasta muy poco',
  'ship.coloso.d': 'Fortaleza con ocho motores: blindada para el cinturón',
  'cls.light': 'Livianas · 20 t',
  'cls.medium': 'Medianas · 60 t',
  'cls.heavy': 'Pesadas · 120 t',
  'fleet.exclusive': 'Diseño exclusivo',
  'fleet.armor': 'Blindada',
  'fleet.bp': 'Plano · US$ {n}',
  'fleet.bpOwned': 'Plano tuyo',
  'fleet.bpBuy': 'Comprar plano',
  'fleet.bpHint': 'Los planos se compran una vez (USDT o BNB) y después construís las naves que quieras con créditos. No son más fuertes que las de fábrica: tienen su diseño propio y otro equilibrio.',
  'fleet.fleetPack': 'Flota Rift: los 9 planos',
  'fleet.fleetPackD': 'Todas las naves exclusivas (US$ 48 sueltas)',
  'fleet.fuel': 'Consumo {v}',
  'hg.cta': 'Hangar Rift: naves exclusivas',
  'hg.ctaSub': '9 diseños propios, mirá cómo quedan evolucionadas',
  'hg.title': 'Hangar Rift',
  'hg.sub': 'Naves de diseño exclusivo. Elegí una, mirala en grande y cómo queda evolucionada.',
  'hg.factory': 'De fábrica',
  'hg.build': 'Construir · {price}',
  'hg.speed': 'Velocidad',
  'hg.fuel': 'Consumo',
  'hg.cap': 'Carga',
  'hg.fleetOwned': 'Tenés todas las naves exclusivas',
  'evo.title': 'Evolución',
  'evo.mk': 'Mk {n}',
  'evo.btn': 'Evolucionar a Mk {n}',
  'evo.max': 'Evolución completa',
  'evo.d': '+{speed}% velocidad · −{fuel}% combustible',
  'toast.evolve': '{ship} evolucionó a Mk {mk}',
  'toast.err.blueprint': 'Primero comprá el plano de esa nave',
  'toast.err.max': 'Ya está al máximo',
  'cargo.agua': 'Agua',
  'cargo.mineral': 'Mineral',
  'cargo.alimentos': 'Alimentos',
  'cargo.combustible': 'Combustible',
  'cargo.piezas': 'Piezas',
  'port.hq': 'Nodo Rift',
  'port.kepa': 'Kepa',
  'port.ferra': 'Ferra',
  'port.vesta': 'Vesta',
  'port.nimbus': 'Nimbus',
  'port.forja': 'Forja',
  'port.kepa.d': 'Luna helada',
  'port.ferra.d': 'Mundo minero',
  'port.vesta.d': 'Colonia jardín',
  'port.nimbus.d': 'Gigante gaseoso',
  'port.forja.d': 'Planeta fábrica',
  'port.hq.d': 'Tu estación',
  'map.sells': 'Vende',
  'map.buys': 'Pide',
  'map.dist': 'A {d} de la estación · {t} con una Colibrí',
  'map.orders': '{n} pedidos abiertos',
  'map.belt': 'Cinturón de asteroides',
  'map.locked': 'Nivel {n}',
  'port.portal': 'Portal Rift',
  'port.umbraGate': 'Portal Umbra',
  'port.heliosGate': 'Portal Helios',
  'port.portal.d': 'Portal de salto',
  'port.umbraGate.d': 'Portal de salto',
  'port.heliosGate.d': 'Portal de salto',
  'port.cripta': 'Cripta',
  'port.brasa': 'Brasa',
  'port.eco': 'Eco',
  'port.aurea': 'Áurea',
  'port.cielo': 'Cielo',
  'port.eden': 'Edén',
  'port.cripta.d': 'Mundo de cristal',
  'port.brasa.d': 'Mundo de lava',
  'port.eco.d': 'Planeta océano',
  'port.aurea.d': 'Desierto dorado',
  'port.cielo.d': 'Gigante helado con anillos',
  'port.eden.d': 'Planeta jardín',
  'sys.rift': 'Rift',
  'sys.umbra': 'Umbra',
  'sys.helios': 'Helios',
  'map.system': 'Sistema',
  'map.all': 'Todo',
  'map.gateNote': 'Las naves saltan entre portales en {t}. Para llegar a otro sistema, la nave vuela al portal y sale por el del otro lado.',
  'status.jump': 'Saltando a {to}',
  'unlock.system': 'Nuevo sistema estelar: {sys}',
  'market.sys': 'Sistema {sys}',
  'menu.lang': 'Idioma',
  'menu.sound': 'Sonido',
  'menu.reset': 'Empezar de nuevo',
  'menu.resetConfirm': '¿Seguro? Se borra todo tu progreso.',
  'menu.riftfall': 'Jugar RIFTFALL',
  'bridge.got': 'Ruta Rift: +{v} por lo que lograste en RIFTFALL',
  'bridge.hint.run': 'Tu primera partida te da {v} acá',
  'bridge.hint.rift': 'Abrí el primer nivel del Rift: {v} acá',
  'bridge.hint.win': 'Ganá una partida: {v} acá',
  'bridge.done': 'Ruta Rift completa',
  'menu.style': 'Taller de estilo',
  'menu.owner': 'Panel del dueño',
  'menu.ownerSub': 'Créditos, nivel y mejoras',
  'owner.btn': 'Dueño',
  'menu.account': 'Cuenta Rift',
  'menu.acctGuest': 'Invitado: protegé tu progreso',
  'menu.acctSafe': 'Protegida',
  'menu.acctOffline': 'Sin conexión',
  'style.title': 'Taller de estilo',
  'style.sub': 'Pintá tu flota y ponele tu nombre. Solo cambia cómo se ve: no da ventaja.',
  'style.open': 'Estilo',
  'style.cta': 'Taller de estilo',
  'style.ctaSub': 'Pinturas, estelas y tu nombre en las naves',
  'style.livery': 'Pintura',
  'style.trail': 'Estela de los motores',
  'style.plate': 'Matrícula',
  'style.plateD': 'El nombre pintado en la nave (hasta 10 letras).',
  'style.platePh': 'Nombre de la nave',
  'style.sign': 'Cartel de la estación',
  'style.signD': 'El nombre de tu empresa en el cartel del techo, en vez de RIFT CARGO.',
  'style.signPh': 'Nombre de tu empresa',
  'style.save': 'Guardar',
  'style.saved': 'Guardado',
  'style.owned': 'Tuya',
  'style.using': 'En uso',
  'style.founderOnly': 'Pase Fundador {tier}',
  'style.founderTag': 'Fundador {tier}',
  'style.founderHint': 'Se consigue con el Pase Fundador {tier} de RIFTFALL.',
  'style.founderGo': 'Ver el Pase Fundador',
  'style.buy': 'Comprar {name}',
  'style.payUsdt': 'Pagar US$ {n} en USDT',
  'style.payBnb': 'Pagar {n} BNB',
  'style.noPrice': 'BNB sin precio ahora',
  'style.pack': 'Pack Rift completo',
  'style.packD': 'Todas las pinturas y estelas, la matrícula y el cartel. Sueltos cuestan US$ 13.',
  'style.packOwned': 'Ya tenés el pack completo',
  'style.restore': '¿Ya compraste en otro dispositivo? Pegá el hash del pago',
  'style.verify': 'Verificar',
  'style.note': 'Los estéticos se pagan en BNB Chain directo al creador del juego. Solo cambian cómo se ve: no dan ventaja, no se canjean por tokens y no son una inversión.',
  'style.stage.wallet': 'Firmá en la wallet…',
  'style.stage.confirm': 'Esperando la red…',
  'style.bought': '¡Listo! {name} ya es tuyo.',
  'style.restored': 'Compra verificada: {name}.',
  'style.err.badHash': 'Ese hash no es válido.',
  'style.err.notFound': 'No encontramos esa transacción en BNB Chain.',
  'style.err.pending': 'La transacción todavía no se confirmó. Probá en un minuto.',
  'style.err.failed': 'Esa transacción falló en la red.',
  'style.err.notStyle': 'Esa transacción no es una compra del Taller de estilo.',
  'style.err.notToTreasury': 'Ese pago no fue a Rift Cargo.',
  'style.err.tooLow': 'El monto no alcanza para ese artículo.',
  'style.err.otherPayer': 'Ese pago lo hizo otra wallet.',
  'style.err.offline': 'Sin conexión con el servidor. Conservá el comprobante si ya pagaste.',
  'style.err.priceUnavailable': 'No se pudo fijar el importe. Probá de nuevo antes de pagar.',
  'style.err.signature': 'No se pudo verificar tu firma. Volvé a conectar la wallet.',
  'style.err.session': 'Volvé a entrar a tu Cuenta Rift antes de continuar.',
  'style.err.tooManyOrders': 'Llegaste al límite de pedidos de hoy. Probá mañana.',
  'style.err.orderExpired': 'El pedido venció antes de confirmarse el pago. Contactá al dueño con el comprobante.',
  'style.err.badOrder': 'El pago no coincide con el pedido. Conservá el comprobante.',
  'style.err.manualReview': 'El pago anterior necesita revisión del dueño. Conservá el comprobante.',
  'style.err.accountChanged': 'Entraste a tu otra cuenta. Reiniciá la compra cuando termine de cargar.',
  'style.err.wrongChain': 'No se pudo comprobar el pago en BNB Chain. No vuelvas a pagar.',
  'style.err.claimed': 'Ese comprobante ya fue reconocido en una cuenta.',
  'style.err.otherItem': 'Ese comprobante corresponde a otro artículo.',
  'style.err.rejected': 'Cancelaste el pago en la wallet.',
  'style.err.noWallet': 'No hay wallet en este navegador.',
  'style.err.generic': 'No se pudo completar: {msg}',
  'liv.rift': 'De fábrica',
  'liv.carbono': 'Carbono',
  'liv.aurora': 'Aurora',
  'liv.solar': 'Solar',
  'liv.fundador': 'Dorado Fundador',
  'liv.prisma': 'Prisma',
  'trail.cian': 'Cian',
  'trail.magenta': 'Magenta',
  'trail.verde': 'Verde',
  'trail.violeta': 'Violeta',
  'trail.dorado': 'Dorada',
  'item.liv': 'Pintura {name}',
  'item.trail': 'Estela {name}',
  'item.plates': 'Matrícula propia',
  'item.sign': 'Cartel propio',
  'item.pack': 'Pack Rift completo',
  'item.ship': 'Plano de la nave {name}',
  'item.fleet': 'Flota Rift (9 planos)',
  'founder.1': 'Piloto',
  'founder.2': 'Oro',
  'founder.3': 'Leyenda',
  'locked': 'Bloqueado'
};

const EN = {
  'brand': 'Rift Cargo',
  'view.station': 'Station',
  'view.map': 'System map',
  'hub.name': 'Rift Node',
  'hub.sub': '{full}% full · {busy}/{docks} docks',
  'live': 'Live',
  'paused': 'Paused',
  'speed': 'Speed',
  'role': 'Operations manager',
  'level': 'Level {n}',
  'kpi.stock': 'Stock on hand',
  'kpi.stockSub': 'of {cap} t',
  'kpi.fleet': 'Ships en route',
  'kpi.fleetSub': '{n} at the station',
  'kpi.ontime': 'On-time delivery',
  'kpi.ontimeSub': '{n} deliveries',
  'kpi.income': 'Income',
  'kpi.incomeSub': 'last 5 min',
  'tab.orders': 'Orders',
  'tab.market': 'Market',
  'tab.fleet': 'Fleet',
  'tab.station': 'Station',
  'tab.map': 'Map',
  'orders.title': 'Orders and freight',
  'orders.empty': 'No orders right now. New ones arrive every few seconds.',
  'order.wants': '{port} needs {tons} t of {cargo}',
  'freight.title': 'Freight: {tons} t of {cargo}',
  'freight.route': '{from} → {to}',
  'order.fromDepot': 'Ships from your depot',
  'order.urgent': 'Urgent',
  'order.due': 'Deliver within {t}',
  'order.expires': 'Offer expires in {t}',
  'order.send': 'Send',
  'order.sendWith': 'Send {ship}',
  'order.pickShip': 'Pick a ship',
  'order.noStock': 'Not enough stock: you have {have} t of {cargo}',
  'order.buyMore': 'Buy at {port}',
  'order.noShip': 'No free ship can carry {tons} t',
  'order.arrives': 'Delivers in {t}',
  'order.late': 'would be late',
  'order.onTime': 'on time',
  'order.net': 'You earn {v}',
  'order.fuel': 'fuel {v}',
  'market.title': 'Market',
  'market.depot': 'Depot',
  'market.free': '{free} t free of {cap} t',
  'market.sells': 'Sells {cargo}',
  'market.price': '{v} per t',
  'market.buyWith': 'Buy {tons} t with {ship}',
  'market.total': 'Total {v} with fuel',
  'market.noSpace': 'The depot is full',
  'market.noShip': 'No free ships',
  'market.locked': 'Unlocks at level {n}',
  'market.back': 'Back in {t}',
  'fleet.title': 'Fleet',
  'fleet.hangar': 'Hangar: {n} of {cap} bays',
  'fleet.buy': 'Buy a ship',
  'fleet.cap': '{t} t',
  'fleet.speed': 'Speed {v}',
  'fleet.auto': 'Autopilot',
  'fleet.autoLocked': 'Upgrade the station to use autopilot',
  'auto.off': 'Off',
  'auto.supply': 'Restock',
  'auto.orders': 'Fulfil orders',
  'auto.freight': 'Haul freight',
  'fleet.full': 'Hangar full: expand the hangar',
  'fleet.trips': '{n} trips · earned {v}',
  'station.title': 'Station upgrades',
  'station.stats': 'Your company',
  'up.docks': 'Docks',
  'up.docks.d': 'More ships loading at once',
  'up.drones': 'Cargo drones',
  'up.drones.d': 'Faster loading and unloading',
  'up.depot': 'Depot',
  'up.depot.d': 'More tons of stock',
  'up.hangar': 'Hangar',
  'up.hangar.d': 'Room for more ships',
  'up.engines': 'Engines',
  'up.engines.d': 'The whole fleet flies faster',
  'up.shields': 'Shields',
  'up.shields.d': 'Cross the asteroid belt at full speed',
  'up.autopilot': 'Autopilot',
  'up.autopilot.d': 'Ships work on their own, even with the game closed',
  'up.max': 'Maxed out',
  'up.buy': 'Upgrade',
  'up.needLevel': 'Level {n}',
  'stat.earned': 'Earnings',
  'stat.delivered': 'Deliveries',
  'stat.tons': 'Tons moved',
  'stat.spent': 'Expenses',
  'status.parked': 'In the hangar',
  'status.queued': 'Waiting for a dock',
  'status.docking': 'Docking',
  'status.docked': 'At the dock',
  'status.waitdrones': 'Waiting for drones',
  'status.working': 'Loading',
  'status.unloading': 'Unloading',
  'status.liftoff': 'Taking off',
  'status.travel': 'Flying to {to}',
  'status.portwork': 'Working at {port}',
  'status.landing': 'Landing',
  'pill.idle': 'Available',
  'pill.loading': 'Loading',
  'pill.route': 'En route',
  'pill.port': 'In port',
  'pill.wait': 'Waiting',
  'track.title': 'Shipment tracking',
  'track.none': 'Send a ship to an order to track it here.',
  'track.order': 'Order #{id}',
  'track.buy': 'Purchase #{id}',
  'track.freight': 'Freight #{id}',
  'track.accepted': 'Accepted',
  'track.loading': 'Loading',
  'track.transit': 'In transit',
  'track.delivered': 'Delivered',
  'track.return': 'Return',
  'track.bought': 'Purchase',
  'track.pickup': 'Pickup',
  'track.unload': 'Unloading',
  'track.to': 'To {port}',
  'track.eta': 'arrives in {t}',
  'track.dock': 'Dock {n}',
  'detail.cargo': 'Cargo',
  'detail.dest': 'Destination',
  'detail.eta': 'Arrival',
  'detail.model': 'Model',
  'detail.cap': 'Capacity',
  'detail.trips': 'Trips',
  'detail.earned': 'Earned',
  'detail.follow': 'Follow with camera',
  'detail.empty': 'Empty',
  'cam.in': 'Zoom in',
  'cam.out': 'Zoom out',
  'cam.left': 'Rotate left',
  'cam.right': 'Rotate right',
  'cam.home': 'Back to the station',
  'toast.delivered': '{ship} delivered {tons} t of {cargo} to {port}',
  'toast.late': '{ship} arrived late at {port}: half pay',
  'toast.loaded': '{ship} loaded {tons} t of {cargo} at {port}',
  'toast.level': 'You reached level {n}!',
  'toast.newShip': 'New ship in the hangar: {ship}',
  'toast.upgrade': 'Upgrade ready: {name}',
  'toast.expired': 'An offer from {port} expired',
  'toast.err.money': 'Not enough money',
  'toast.err.stock': 'Not enough stock',
  'toast.err.space': 'The depot is full',
  'toast.err.busy': 'That ship is busy',
  'toast.err.cap': 'It does not fit in that ship',
  'toast.err.level': 'Your level is too low',
  'toast.err.hangar': 'No room in the hangar',
  'toast.err.gone': 'That offer is gone',
  'toast.err.locked': 'Not unlocked yet',
  'unlock.title': 'Level {n}',
  'unlock.sub': 'Your reputation grows. Unlocked:',
  'unlock.ok': "Let's go!",
  'unlock.port': 'New planet: {port}',
  'unlock.ship': 'New ship: {ship}',
  'unlock.up': 'Upgrade: {name}',
  'unlock.more': 'Bigger, better-paid orders',
  'away.title': 'While you were away',
  'away.sub': 'Your fleet kept working for {t}.',
  'away.earned': 'Earnings',
  'away.delivered': 'Deliveries',
  'away.ok': 'Continue',
  'away.tip': 'With autopilot your ships keep working even when the game is closed.',
  'tut.1': 'Welcome to Rift Cargo! You run operations at Rift Node, a cargo station. Your first order is here: Vesta needs water.',
  'tut.1b': 'Tap Send to dispatch a ship.',
  'tut.2': 'Drones carry the containers from the racks to the ship at the dock.',
  'tut.3': 'The ship is off to Vesta. Open the map to see its route.',
  'tut.4': 'Planets orbit the sun, so distances change all the time. A short trip burns less fuel and arrives sooner.',
  'tut.5': 'To keep stock, buy cargo in the Market. Then sell it through orders.',
  'tut.next': 'Next',
  'tut.ok': 'Got it',
  'tut.skip': 'Skip',
  'ship.colibri': 'Hummingbird',
  'ship.mula': 'Mule',
  'ship.titan': 'Titan',
  'ship.colibri.d': 'Light and fast',
  'ship.mula.d': 'The workhorse',
  'ship.titan.d': 'Heavy freighter',
  'ship.vencejo': 'Swift',
  'ship.libelula': 'Dragonfly',
  'ship.halcon': 'Rift Falcon',
  'ship.raya': 'Manta',
  'ship.nomada': 'Nomad',
  'ship.bisonte': 'Bison',
  'ship.nova': 'Nova',
  'ship.leviatan': 'Leviathan',
  'ship.coloso': 'Colossus',
  'ship.vencejo.d': 'Delta wing with twin tails: the fastest light ship',
  'ship.libelula.d': 'Four wings with solar panels: sips fuel',
  'ship.halcon.d': 'Armored, forward-swept wings: crosses the belt at full speed',
  'ship.raya.d': 'Manta body, flat and fast',
  'ship.nomada.d': 'Caravan with solar sails and an ion drive: the thriftiest',
  'ship.bisonte.d': 'Heavy armor and a ram: the belt does not slow it down',
  'ship.nova.d': 'Cruiser with an accelerator ring: the fastest heavy ship',
  'ship.leviatan.d': 'A glowing space whale: sips fuel',
  'ship.coloso.d': 'Eight-engine fortress: armored for the belt',
  'cls.light': 'Light · 20 t',
  'cls.medium': 'Medium · 60 t',
  'cls.heavy': 'Heavy · 120 t',
  'fleet.exclusive': 'Exclusive design',
  'fleet.armor': 'Armored',
  'fleet.bp': 'Blueprint · US$ {n}',
  'fleet.bpOwned': 'Blueprint owned',
  'fleet.bpBuy': 'Buy blueprint',
  'fleet.bpHint': 'Buy a blueprint once (USDT or BNB) and then build as many ships as you want with credits. They are not stronger than factory ships: they have their own design and a different balance.',
  'fleet.fleetPack': 'Rift Fleet: all 9 blueprints',
  'fleet.fleetPackD': 'Every exclusive ship (US$ 48 separately)',
  'fleet.fuel': 'Fuel {v}',
  'hg.cta': 'Rift Hangar: exclusive ships',
  'hg.ctaSub': '9 original designs, see them fully evolved',
  'hg.title': 'Rift Hangar',
  'hg.sub': 'Ships with exclusive designs. Pick one, see it up close and how it looks evolved.',
  'hg.factory': 'Factory',
  'hg.build': 'Build · {price}',
  'hg.speed': 'Speed',
  'hg.fuel': 'Fuel use',
  'hg.cap': 'Cargo',
  'hg.fleetOwned': 'You own every exclusive ship',
  'evo.title': 'Evolution',
  'evo.mk': 'Mk {n}',
  'evo.btn': 'Evolve to Mk {n}',
  'evo.max': 'Fully evolved',
  'evo.d': '+{speed}% speed · −{fuel}% fuel',
  'toast.evolve': '{ship} evolved to Mk {mk}',
  'toast.err.blueprint': 'Buy that ship\'s blueprint first',
  'toast.err.max': 'Already maxed out',
  'cargo.agua': 'Water',
  'cargo.mineral': 'Ore',
  'cargo.alimentos': 'Food',
  'cargo.combustible': 'Fuel',
  'cargo.piezas': 'Parts',
  'port.hq': 'Rift Node',
  'port.kepa': 'Kepa',
  'port.ferra': 'Ferra',
  'port.vesta': 'Vesta',
  'port.nimbus': 'Nimbus',
  'port.forja': 'Forge',
  'port.kepa.d': 'Ice moon',
  'port.ferra.d': 'Mining world',
  'port.vesta.d': 'Garden colony',
  'port.nimbus.d': 'Gas giant',
  'port.forja.d': 'Factory planet',
  'port.hq.d': 'Your station',
  'map.sells': 'Sells',
  'map.buys': 'Wants',
  'map.dist': '{d} from the station · {t} by Hummingbird',
  'map.orders': '{n} open orders',
  'map.belt': 'Asteroid belt',
  'map.locked': 'Level {n}',
  'port.portal': 'Rift Gate',
  'port.umbraGate': 'Umbra Gate',
  'port.heliosGate': 'Helios Gate',
  'port.portal.d': 'Jump gate',
  'port.umbraGate.d': 'Jump gate',
  'port.heliosGate.d': 'Jump gate',
  'port.cripta': 'Crypta',
  'port.brasa': 'Ember',
  'port.eco': 'Echo',
  'port.aurea': 'Aurea',
  'port.cielo': 'Skye',
  'port.eden': 'Eden',
  'port.cripta.d': 'Crystal world',
  'port.brasa.d': 'Lava world',
  'port.eco.d': 'Ocean planet',
  'port.aurea.d': 'Golden desert',
  'port.cielo.d': 'Ringed ice giant',
  'port.eden.d': 'Garden planet',
  'sys.rift': 'Rift',
  'sys.umbra': 'Umbra',
  'sys.helios': 'Helios',
  'map.system': 'System',
  'map.all': 'All',
  'map.gateNote': 'Ships jump between gates in {t}. To reach another system, a ship flies to the gate and comes out of the one on the other side.',
  'status.jump': 'Jumping to {to}',
  'unlock.system': 'New star system: {sys}',
  'market.sys': '{sys} system',
  'menu.lang': 'Language',
  'menu.sound': 'Sound',
  'menu.reset': 'Start over',
  'menu.resetConfirm': 'Are you sure? All your progress will be erased.',
  'menu.riftfall': 'Play RIFTFALL',
  'bridge.got': 'Rift Route: +{v} for what you did in RIFTFALL',
  'bridge.hint.run': 'Your first run gives you {v} here',
  'bridge.hint.rift': 'Open the first Rift level: {v} here',
  'bridge.hint.win': 'Win a run: {v} here',
  'bridge.done': 'Rift Route complete',
  'menu.style': 'Style workshop',
  'menu.owner': 'Owner panel',
  'menu.ownerSub': 'Credits, level and upgrades',
  'owner.btn': 'Owner',
  'menu.account': 'Rift Account',
  'menu.acctGuest': 'Guest: secure your progress',
  'menu.acctSafe': 'Secured',
  'menu.acctOffline': 'Offline',
  'style.title': 'Style workshop',
  'style.sub': 'Paint your fleet and give it your name. Looks only: no gameplay advantage.',
  'style.open': 'Style',
  'style.cta': 'Style workshop',
  'style.ctaSub': 'Paint jobs, engine trails and your name on your ships',
  'style.livery': 'Paint job',
  'style.trail': 'Engine trail',
  'style.plate': 'Ship name',
  'style.plateD': 'The name painted on the ship (up to 10 letters).',
  'style.platePh': 'Ship name',
  'style.sign': 'Station sign',
  'style.signD': 'Your company name on the roof sign instead of RIFT CARGO.',
  'style.signPh': 'Your company name',
  'style.save': 'Save',
  'style.saved': 'Saved',
  'style.owned': 'Owned',
  'style.using': 'In use',
  'style.founderOnly': 'Founder Pass {tier}',
  'style.founderTag': 'Founder {tier}',
  'style.founderHint': 'Comes with the RIFTFALL Founder Pass {tier}.',
  'style.founderGo': 'See the Founder Pass',
  'style.buy': 'Buy {name}',
  'style.payUsdt': 'Pay US$ {n} in USDT',
  'style.payBnb': 'Pay {n} BNB',
  'style.noPrice': 'No BNB price right now',
  'style.pack': 'Full Rift pack',
  'style.packD': 'Every paint job and trail, ship names and the station sign. US$ 13 if bought separately.',
  'style.packOwned': 'You already own the full pack',
  'style.restore': 'Bought on another device? Paste the payment hash',
  'style.verify': 'Verify',
  'style.note': 'Cosmetics are paid on BNB Chain directly to the game creator. They only change how the game looks: no advantage, not redeemable for tokens and not an investment.',
  'style.stage.wallet': 'Sign in your wallet…',
  'style.stage.confirm': 'Waiting for the network…',
  'style.bought': 'Done! {name} is yours.',
  'style.restored': 'Purchase verified: {name}.',
  'style.err.badHash': 'That hash is not valid.',
  'style.err.notFound': 'We could not find that transaction on BNB Chain.',
  'style.err.pending': 'The transaction is not confirmed yet. Try again in a minute.',
  'style.err.failed': 'That transaction failed on the network.',
  'style.err.notStyle': 'That transaction is not a Style workshop purchase.',
  'style.err.notToTreasury': 'That payment did not go to Rift Cargo.',
  'style.err.tooLow': 'The amount is too low for that item.',
  'style.err.otherPayer': 'That payment was made by another wallet.',
  'style.err.offline': 'No server connection. Keep your receipt if you already paid.',
  'style.err.priceUnavailable': 'Could not fix the amount. Try again before paying.',
  'style.err.signature': 'Your signature could not be verified. Connect your wallet again.',
  'style.err.session': 'Sign in to your Rift Account again before continuing.',
  'style.err.tooManyOrders': 'You reached today’s order limit. Try tomorrow.',
  'style.err.orderExpired': 'The order expired before payment confirmation. Contact the owner with your receipt.',
  'style.err.badOrder': 'The payment does not match the order. Keep your receipt.',
  'style.err.manualReview': 'This previous payment needs owner review. Keep your receipt.',
  'style.err.accountChanged': 'You signed in to your other account. Restart the purchase after it loads.',
  'style.err.wrongChain': 'Could not check the payment on BNB Chain. Do not pay again.',
  'style.err.claimed': 'That receipt was already recognized on an account.',
  'style.err.otherItem': 'That receipt belongs to another item.',
  'style.err.rejected': 'You cancelled the payment in your wallet.',
  'style.err.noWallet': 'There is no wallet in this browser.',
  'style.err.generic': 'Could not complete it: {msg}',
  'liv.rift': 'Factory',
  'liv.carbono': 'Carbon',
  'liv.aurora': 'Aurora',
  'liv.solar': 'Solar',
  'liv.fundador': 'Founder Gold',
  'liv.prisma': 'Prism',
  'trail.cian': 'Cyan',
  'trail.magenta': 'Magenta',
  'trail.verde': 'Green',
  'trail.violeta': 'Violet',
  'trail.dorado': 'Gold',
  'item.liv': '{name} paint job',
  'item.trail': '{name} trail',
  'item.plates': 'Custom ship names',
  'item.sign': 'Custom station sign',
  'item.pack': 'Full Rift pack',
  'item.ship': '{name} blueprint',
  'item.fleet': 'Rift Fleet (9 blueprints)',
  'founder.1': 'Pilot',
  'founder.2': 'Gold',
  'founder.3': 'Legend',
  'locked': 'Locked'
};

const PT = {
  ...EN,
  'view.station': 'Estação',
  'view.map': 'Mapa do sistema',
  'hub.name': 'Nó Rift',
  'hub.sub': '{full}% cheio · {busy}/{docks} docas',
  'live': 'Ao vivo',
  'paused': 'Pausa',
  'speed': 'Velocidade',
  'role': 'Chefe de operações',
  'level': 'Nível {n}',
  'kpi.stock': 'Estoque no depósito',
  'kpi.stockSub': 'de {cap} t',
  'kpi.fleet': 'Naves em rota',
  'kpi.fleetSub': '{n} na estação',
  'kpi.ontime': 'Entregas no prazo',
  'kpi.ontimeSub': '{n} entregas',
  'kpi.income': 'Receita',
  'kpi.incomeSub': 'últimos 5 min',
  'tab.orders': 'Pedidos',
  'tab.market': 'Mercado',
  'tab.fleet': 'Frota',
  'tab.station': 'Estação',
  'tab.map': 'Mapa',
  'orders.title': 'Pedidos e fretes',
  'orders.empty': 'Sem pedidos agora. Chegam novos a cada poucos segundos.',
  'order.wants': '{port} pede {tons} t de {cargo}',
  'freight.title': 'Frete: {tons} t de {cargo}',
  'order.fromDepot': 'Sai do depósito',
  'order.urgent': 'Urgente',
  'order.due': 'Entregar em {t}',
  'order.expires': 'A oferta vence em {t}',
  'order.send': 'Enviar',
  'order.sendWith': 'Enviar {ship}',
  'order.pickShip': 'Escolha a nave',
  'order.noStock': 'Falta estoque: você tem {have} t de {cargo}',
  'order.buyMore': 'Comprar em {port}',
  'order.noShip': 'Nenhuma nave livre leva {tons} t',
  'order.arrives': 'Entrega em {t}',
  'order.late': 'chegaria atrasada',
  'order.onTime': 'no prazo',
  'order.net': 'Você ganha {v}',
  'order.fuel': 'combustível {v}',
  'market.depot': 'Depósito',
  'market.free': '{free} t livres de {cap} t',
  'market.sells': 'Vende {cargo}',
  'market.price': '{v} por t',
  'market.buyWith': 'Comprar {tons} t com {ship}',
  'market.total': 'Total {v} com combustível',
  'market.noSpace': 'O depósito está cheio',
  'market.noShip': 'Nenhuma nave livre',
  'market.locked': 'Libera no nível {n}',
  'market.back': 'Volta em {t}',
  'fleet.title': 'Frota',
  'fleet.hangar': 'Hangar: {n} de {cap} vagas',
  'fleet.buy': 'Comprar nave',
  'fleet.speed': 'Velocidade {v}',
  'fleet.auto': 'Piloto automático',
  'fleet.autoLocked': 'Melhore a estação para usar o piloto automático',
  'auto.off': 'Desligado',
  'auto.supply': 'Repor estoque',
  'auto.orders': 'Cumprir pedidos',
  'auto.freight': 'Fazer fretes',
  'fleet.full': 'Hangar cheio: amplie o hangar',
  'fleet.trips': '{n} viagens · ganhou {v}',
  'station.title': 'Melhorias da estação',
  'station.stats': 'Sua empresa',
  'up.docks': 'Docas',
  'up.docks.d': 'Mais naves carregando ao mesmo tempo',
  'up.drones': 'Drones de carga',
  'up.drones.d': 'Carregam e descarregam mais rápido',
  'up.depot': 'Depósito',
  'up.depot.d': 'Mais toneladas de estoque',
  'up.hangar': 'Hangar',
  'up.hangar.d': 'Espaço para mais naves',
  'up.engines': 'Motores',
  'up.engines.d': 'Toda a frota voa mais rápido',
  'up.shields': 'Escudos',
  'up.shields.d': 'Cruzar o cinturão de asteroides sem frear',
  'up.autopilot': 'Piloto automático',
  'up.autopilot.d': 'As naves trabalham sozinhas, mesmo com o jogo fechado',
  'up.max': 'No máximo',
  'up.buy': 'Melhorar',
  'up.needLevel': 'Nível {n}',
  'stat.earned': 'Ganhos',
  'stat.delivered': 'Entregas',
  'stat.tons': 'Toneladas movidas',
  'stat.spent': 'Gastos',
  'status.parked': 'No hangar',
  'status.queued': 'Esperando doca',
  'status.docking': 'Entrando na doca',
  'status.docked': 'Na doca',
  'status.waitdrones': 'Esperando drones',
  'status.working': 'Carregando',
  'status.unloading': 'Descarregando',
  'status.liftoff': 'Decolando',
  'status.travel': 'Viajando para {to}',
  'status.portwork': 'Operando em {port}',
  'status.landing': 'Pousando',
  'pill.idle': 'Disponível',
  'pill.loading': 'Carregando',
  'pill.route': 'Em rota',
  'pill.port': 'No porto',
  'pill.wait': 'Em espera',
  'track.title': 'Rastreamento de envio',
  'track.none': 'Envie uma nave a um pedido para acompanhá-la aqui.',
  'track.order': 'Pedido #{id}',
  'track.buy': 'Compra #{id}',
  'track.freight': 'Frete #{id}',
  'track.accepted': 'Aceito',
  'track.loading': 'Carga',
  'track.transit': 'Em viagem',
  'track.delivered': 'Entregue',
  'track.return': 'Retorno',
  'track.bought': 'Compra',
  'track.pickup': 'Coleta',
  'track.unload': 'Descarga',
  'track.to': 'Para {port}',
  'track.eta': 'chega em {t}',
  'track.dock': 'Doca {n}',
  'detail.cargo': 'Carga',
  'detail.dest': 'Destino',
  'detail.eta': 'Chegada',
  'detail.model': 'Modelo',
  'detail.cap': 'Capacidade',
  'detail.trips': 'Viagens',
  'detail.earned': 'Ganhou',
  'detail.follow': 'Seguir com a câmera',
  'detail.empty': 'Vazia',
  'cam.in': 'Aproximar',
  'cam.out': 'Afastar',
  'cam.left': 'Girar à esquerda',
  'cam.right': 'Girar à direita',
  'cam.home': 'Voltar à estação',
  'toast.delivered': '{ship} entregou {tons} t de {cargo} em {port}',
  'toast.late': '{ship} chegou atrasada em {port}: recebe a metade',
  'toast.loaded': '{ship} carregou {tons} t de {cargo} em {port}',
  'toast.level': 'Você subiu para o nível {n}!',
  'toast.newShip': 'Nova nave no hangar: {ship}',
  'toast.upgrade': 'Melhoria pronta: {name}',
  'toast.expired': 'Uma oferta de {port} venceu',
  'toast.err.money': 'Dinheiro insuficiente',
  'toast.err.stock': 'Estoque insuficiente',
  'toast.err.space': 'Não há espaço no depósito',
  'toast.err.busy': 'Essa nave está ocupada',
  'toast.err.cap': 'Não cabe nessa nave',
  'toast.err.level': 'Seu nível ainda é baixo',
  'toast.err.hangar': 'Não há vaga no hangar',
  'toast.err.gone': 'Essa oferta não existe mais',
  'toast.err.locked': 'Ainda não liberado',
  'unlock.title': 'Nível {n}',
  'unlock.sub': 'Sua reputação cresce. Liberado:',
  'unlock.ok': 'Vamos!',
  'unlock.port': 'Novo planeta: {port}',
  'unlock.ship': 'Nova nave: {ship}',
  'unlock.up': 'Melhoria: {name}',
  'unlock.more': 'Pedidos maiores e mais bem pagos',
  'away.title': 'Enquanto você estava fora',
  'away.sub': 'Sua frota continuou trabalhando por {t}.',
  'away.earned': 'Ganhos',
  'away.delivered': 'Entregas',
  'away.ok': 'Continuar',
  'away.tip': 'Com piloto automático suas naves trabalham mesmo com o jogo fechado.',
  'tut.1': 'Bem-vindo ao Rift Cargo! Você é o chefe de operações do Nó Rift, uma estação de carga. Chegou seu primeiro pedido: Vesta precisa de água.',
  'tut.1b': 'Toque em Enviar para mandar uma nave.',
  'tut.2': 'Os drones levam os contêineres das prateleiras até a nave na doca.',
  'tut.3': 'A nave parte para Vesta. Abra o mapa para ver a rota.',
  'tut.4': 'Os planetas giram ao redor do sol: as distâncias mudam o tempo todo. Uma viagem curta gasta menos combustível e chega antes.',
  'tut.5': 'Para ter estoque, compre carga no Mercado. Depois venda com os pedidos.',
  'tut.next': 'Próximo',
  'tut.ok': 'Entendi',
  'tut.skip': 'Pular',
  'ship.colibri': 'Colibri',
  'ship.mula': 'Mula',
  'ship.titan': 'Titã',
  'ship.colibri.d': 'Leve e rápida',
  'ship.mula.d': 'A mais versátil',
  'ship.titan.d': 'Cargueiro pesado',
  'ship.vencejo': 'Andorinhão',
  'ship.libelula': 'Libélula',
  'ship.halcon': 'Falcão Rift',
  'ship.raya': 'Raia',
  'ship.nomada': 'Nômade',
  'ship.bisonte': 'Bisão',
  'ship.nova': 'Nova',
  'ship.leviatan': 'Leviatã',
  'ship.coloso': 'Colosso',
  'ship.vencejo.d': 'Asa delta com cauda dupla: a mais rápida das leves',
  'ship.libelula.d': 'Quatro asas com painéis solares: gasta muito pouco',
  'ship.halcon.d': 'Blindada, de asas invertidas: cruza o cinturão sem frear',
  'ship.raya.d': 'Corpo de arraia, plano e veloz',
  'ship.nomada.d': 'Caravana com velas solares e motor iônico: a mais econômica',
  'ship.bisonte.d': 'Blindagem pesada e aríete: o cinturão não a freia',
  'ship.nova.d': 'Cruzador com anel acelerador: o pesado mais rápido',
  'ship.leviatan.d': 'Baleia espacial com luz própria: gasta muito pouco',
  'ship.coloso.d': 'Fortaleza com oito motores: blindada para o cinturão',
  'cls.light': 'Leves · 20 t',
  'cls.medium': 'Médias · 60 t',
  'cls.heavy': 'Pesadas · 120 t',
  'fleet.exclusive': 'Design exclusivo',
  'fleet.armor': 'Blindada',
  'fleet.bp': 'Projeto · US$ {n}',
  'fleet.bpOwned': 'Projeto seu',
  'fleet.bpBuy': 'Comprar projeto',
  'fleet.bpHint': 'O projeto é comprado uma vez (USDT ou BNB) e depois você constrói quantas naves quiser com créditos. Não são mais fortes que as de fábrica: têm design próprio e outro equilíbrio.',
  'fleet.fleetPack': 'Frota Rift: os 9 projetos',
  'fleet.fleetPackD': 'Todas as naves exclusivas (US$ 48 separadas)',
  'fleet.fuel': 'Consumo {v}',
  'hg.cta': 'Hangar Rift: naves exclusivas',
  'hg.ctaSub': '9 designs próprios, veja como ficam evoluídas',
  'hg.title': 'Hangar Rift',
  'hg.sub': 'Naves de design exclusivo. Escolha uma, veja de perto e como fica evoluída.',
  'hg.factory': 'De fábrica',
  'hg.build': 'Construir · {price}',
  'hg.speed': 'Velocidade',
  'hg.fuel': 'Consumo',
  'hg.cap': 'Carga',
  'hg.fleetOwned': 'Você tem todas as naves exclusivas',
  'evo.title': 'Evolução',
  'evo.mk': 'Mk {n}',
  'evo.btn': 'Evoluir para Mk {n}',
  'evo.max': 'Evolução completa',
  'evo.d': '+{speed}% velocidade · −{fuel}% combustível',
  'toast.evolve': '{ship} evoluiu para Mk {mk}',
  'toast.err.blueprint': 'Primeiro compre o projeto dessa nave',
  'toast.err.max': 'Já está no máximo',
  'cargo.agua': 'Água',
  'cargo.mineral': 'Minério',
  'cargo.alimentos': 'Alimentos',
  'cargo.combustible': 'Combustível',
  'cargo.piezas': 'Peças',
  'port.hq': 'Nó Rift',
  'port.forja': 'Forja',
  'port.kepa.d': 'Lua gelada',
  'port.ferra.d': 'Mundo minerador',
  'port.vesta.d': 'Colônia jardim',
  'port.nimbus.d': 'Gigante gasoso',
  'port.forja.d': 'Planeta fábrica',
  'port.hq.d': 'Sua estação',
  'map.sells': 'Vende',
  'map.buys': 'Pede',
  'map.dist': 'A {d} da estação · {t} com uma Colibri',
  'map.orders': '{n} pedidos abertos',
  'map.belt': 'Cinturão de asteroides',
  'map.locked': 'Nível {n}',
  'port.portal': 'Portal Rift',
  'port.umbraGate': 'Portal Umbra',
  'port.heliosGate': 'Portal Helios',
  'port.portal.d': 'Portal de salto',
  'port.umbraGate.d': 'Portal de salto',
  'port.heliosGate.d': 'Portal de salto',
  'port.cripta': 'Cripta',
  'port.brasa': 'Brasa',
  'port.eco': 'Eco',
  'port.aurea': 'Áurea',
  'port.cielo': 'Céu',
  'port.eden': 'Éden',
  'port.cripta.d': 'Mundo de cristal',
  'port.brasa.d': 'Mundo de lava',
  'port.eco.d': 'Planeta oceano',
  'port.aurea.d': 'Deserto dourado',
  'port.cielo.d': 'Gigante gelado com anéis',
  'port.eden.d': 'Planeta jardim',
  'sys.rift': 'Rift',
  'sys.umbra': 'Umbra',
  'sys.helios': 'Helios',
  'map.system': 'Sistema',
  'map.all': 'Tudo',
  'map.gateNote': 'As naves saltam entre portais em {t}. Para chegar a outro sistema, a nave voa até o portal e sai pelo do outro lado.',
  'status.jump': 'Saltando para {to}',
  'unlock.system': 'Novo sistema estelar: {sys}',
  'market.sys': 'Sistema {sys}',
  'menu.lang': 'Idioma',
  'menu.sound': 'Som',
  'menu.reset': 'Começar de novo',
  'menu.resetConfirm': 'Tem certeza? Todo o seu progresso será apagado.',
  'menu.riftfall': 'Jogar RIFTFALL',
  'bridge.got': 'Rota Rift: +{v} pelo que você fez no RIFTFALL',
  'bridge.hint.run': 'Sua primeira partida te dá {v} aqui',
  'bridge.hint.rift': 'Abra o primeiro nível do Rift: {v} aqui',
  'bridge.hint.win': 'Vença uma partida: {v} aqui',
  'bridge.done': 'Rota Rift completa',
  'menu.style': 'Oficina de estilo',
  'menu.owner': 'Painel do dono',
  'menu.ownerSub': 'Créditos, nível e melhorias',
  'owner.btn': 'Dono',
  'menu.account': 'Conta Rift',
  'menu.acctGuest': 'Convidado: proteja seu progresso',
  'menu.acctSafe': 'Protegida',
  'menu.acctOffline': 'Sem conexão',
  'style.title': 'Oficina de estilo',
  'style.sub': 'Pinte sua frota e dê seu nome a ela. Só muda o visual: não dá vantagem.',
  'style.open': 'Estilo',
  'style.cta': 'Oficina de estilo',
  'style.ctaSub': 'Pinturas, rastros e seu nome nas naves',
  'style.livery': 'Pintura',
  'style.trail': 'Rastro dos motores',
  'style.plate': 'Matrícula',
  'style.plateD': 'O nome pintado na nave (até 10 letras).',
  'style.platePh': 'Nome da nave',
  'style.sign': 'Placa da estação',
  'style.signD': 'O nome da sua empresa na placa do telhado, no lugar de RIFT CARGO.',
  'style.signPh': 'Nome da sua empresa',
  'style.save': 'Salvar',
  'style.saved': 'Salvo',
  'style.owned': 'Sua',
  'style.using': 'Em uso',
  'style.founderOnly': 'Passe Fundador {tier}',
  'style.founderTag': 'Fundador {tier}',
  'style.founderHint': 'Vem com o Passe Fundador {tier} do RIFTFALL.',
  'style.founderGo': 'Ver o Passe Fundador',
  'style.buy': 'Comprar {name}',
  'style.payUsdt': 'Pagar US$ {n} em USDT',
  'style.payBnb': 'Pagar {n} BNB',
  'style.noPrice': 'BNB sem preço agora',
  'style.pack': 'Pack Rift completo',
  'style.packD': 'Todas as pinturas e rastros, a matrícula e a placa. Separados custam US$ 13.',
  'style.packOwned': 'Você já tem o pack completo',
  'style.restore': 'Já comprou em outro aparelho? Cole o hash do pagamento',
  'style.verify': 'Verificar',
  'style.note': 'Os itens visuais são pagos na BNB Chain direto ao criador do jogo. Só mudam o visual: não dão vantagem, não são trocados por tokens e não são um investimento.',
  'style.stage.wallet': 'Assine na carteira…',
  'style.stage.confirm': 'Aguardando a rede…',
  'style.bought': 'Pronto! {name} já é seu.',
  'style.restored': 'Compra verificada: {name}.',
  'style.err.badHash': 'Esse hash não é válido.',
  'style.err.notFound': 'Não encontramos essa transação na BNB Chain.',
  'style.err.pending': 'A transação ainda não foi confirmada. Tente em um minuto.',
  'style.err.failed': 'Essa transação falhou na rede.',
  'style.err.notStyle': 'Essa transação não é uma compra da Oficina de estilo.',
  'style.err.notToTreasury': 'Esse pagamento não foi para o Rift Cargo.',
  'style.err.tooLow': 'O valor não é suficiente para esse item.',
  'style.err.otherPayer': 'Esse pagamento foi feito por outra carteira.',
  'style.err.offline': 'Sem conexão com o servidor. Guarde o comprovante se já pagou.',
  'style.err.priceUnavailable': 'Não foi possível fixar o valor. Tente novamente antes de pagar.',
  'style.err.signature': 'Não foi possível verificar sua assinatura. Conecte a carteira novamente.',
  'style.err.session': 'Entre novamente na sua Conta Rift antes de continuar.',
  'style.err.tooManyOrders': 'Você atingiu o limite de pedidos de hoje. Tente amanhã.',
  'style.err.orderExpired': 'O pedido venceu antes da confirmação. Contate o dono com o comprovante.',
  'style.err.badOrder': 'O pagamento não corresponde ao pedido. Guarde o comprovante.',
  'style.err.manualReview': 'Esse pagamento anterior precisa de revisão do dono. Guarde o comprovante.',
  'style.err.accountChanged': 'Você entrou na outra conta. Reinicie a compra depois de carregar.',
  'style.err.wrongChain': 'Não foi possível conferir o pagamento na BNB Chain. Não pague novamente.',
  'style.err.claimed': 'Esse comprovante já foi reconhecido em uma conta.',
  'style.err.otherItem': 'Esse comprovante pertence a outro artigo.',
  'style.err.rejected': 'Você cancelou o pagamento na carteira.',
  'style.err.noWallet': 'Não há carteira neste navegador.',
  'style.err.generic': 'Não foi possível concluir: {msg}',
  'liv.rift': 'De fábrica',
  'liv.carbono': 'Carbono',
  'liv.aurora': 'Aurora',
  'liv.solar': 'Solar',
  'liv.fundador': 'Dourado Fundador',
  'liv.prisma': 'Prisma',
  'trail.cian': 'Ciano',
  'trail.magenta': 'Magenta',
  'trail.verde': 'Verde',
  'trail.violeta': 'Violeta',
  'trail.dorado': 'Dourado',
  'item.liv': 'Pintura {name}',
  'item.trail': 'Rastro {name}',
  'item.plates': 'Matrícula própria',
  'item.sign': 'Placa própria',
  'item.pack': 'Pack Rift completo',
  'item.ship': 'Projeto da nave {name}',
  'item.fleet': 'Frota Rift (9 projetos)',
  'founder.1': 'Piloto',
  'founder.2': 'Ouro',
  'founder.3': 'Lenda',
  'locked': 'Bloqueado'
};

const DICTS = { es: ES, en: EN, pt: PT };
const KEY = 'riftcargo.lang';

function detect() {
  try {
    const saved = localStorage.getItem(KEY);
    if (saved && DICTS[saved]) return saved;
  } catch {}
  const nav = (navigator.language || 'es').slice(0, 2).toLowerCase();
  return DICTS[nav] ? nav : 'en';
}

export let lang = detect();
export function setLang(l) {
  lang = DICTS[l] ? l : 'es';
  try { localStorage.setItem(KEY, lang); } catch {}
  document.documentElement.lang = lang;
}
document.documentElement.lang = lang;

export function t(key, vars) {
  let s = DICTS[lang][key] ?? ES[key] ?? key;
  if (vars) for (const [k, v] of Object.entries(vars)) s = s.replaceAll(`{${k}}`, v);
  return s;
}

const nf = () => new Intl.NumberFormat(lang === 'en' ? 'en-US' : lang === 'pt' ? 'pt-BR' : 'es-AR');
export const num = (n) => nf().format(Math.round(n));
export const money = (n) => `${n < 0 ? '−' : ''}$${num(Math.abs(n))}`;
export const pct = (k) => `${new Intl.NumberFormat(lang === 'en' ? 'en-US' : 'es-AR', { maximumFractionDigits: 1 }).format(k * 100)}%`;
export function dur(sec) {
  sec = Math.max(0, Math.round(sec));
  if (sec >= 3600) return `${Math.floor(sec / 3600)} h ${Math.floor((sec % 3600) / 60)} min`;
  return `${Math.floor(sec / 60)}:${String(sec % 60).padStart(2, '0')}`;
}
